
import {useEffect, useState} from 'react';
import axios from 'axios';
import getFormattedError from './get-formatted-error';
import {isEmpty} from 'lodash';

const defaultResponse = {
    data: [],
    isLoading: false,
    error: null
};

const getOptions = apiOptions => {
    const {method = 'GET', headers = {}} = apiOptions;
    if (sessionStorage.getItem('carrierCode')) {
        headers.carrierCode = sessionStorage.getItem('carrierCode');
    }
    return {
        ...apiOptions,
        method,
        headers: {
            'content-type': 'application/json',
            ...headers
        }
    };
};


const useApi = (apiDetails, responseData = defaultResponse) => {
    const [apiOptions, setApiOptions] = useState(apiDetails);
    const [response, setResponse] = useState(responseData);

    useEffect(() => {
        const fetchData = async () => {
            const { url = '', transformData = [] } = apiOptions;

            if (isEmpty(url)) {
                return;
            }

            if (!isEmpty(transformData)) {
                apiOptions.transformResponse = transformData;
            }

            setResponse({...responseData, isLoading: true});
            try {
                const responseReceived = await axios(getOptions(apiOptions));
                const updatedResponse = isEmpty(transformData) ? {data: responseReceived.data, error: null, isLoading: false} : responseReceived;
                setResponse(updatedResponse);
            } catch (error) {
                setResponse({
                    data: [],
                    error: getFormattedError(error),
                    isLoading: false
                });
            }
        };

        fetchData();
    }, [apiOptions, responseData]);

    return [response, setApiOptions];
};

export default useApi;
